import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import { TextField as FormikTextField } from 'material-ui-formik-components/TextField';
import { Field, Formik } from 'formik';

import { getString } from '../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class IconTextField extends React.Component {
  constructor(props) {
    super(props);

    this.clearField = this.clearField.bind(this);
  }

  clearField() {
    const { clear } = this.props;
    this.inputRef.focus();
    clear();
  }

  render() {
    const {
      classes,
      id,
      icon,
      iconColour,
      label,
      value,
      placeholder,
      onChange,
      autoFocus,
      required,
      error,
      helpText,
      maxLength,
      type,
      clear,
      readOnly,
      disabled,
      multiline,
      formik,
      onKeyUp,
      ...rest
    } = this.props;

    const Icon = icon;

    const inputRef = (input) => (this.inputRef = input);

    // Attributes shared by both Formik text fields and non-Formik text fields.
    const sharedFieldAttributes = {
      id: id,
      name: id,
      label: label,
      value: value,
      placeholder: placeholder,
      className: classes.formControl,
      InputLabelProps: {
        classes: {
          root: classes.label,
          shrink: classes.shrink,
        },
        shrink: true,
      },
      InputProps: {
        classes: {
          root: classes.value,
          input: multiline
            ? `${classes.input} ${classes.inputMultiline}`
            : classes.input,
          disabled: classes.disabled,
        },
        type: type,
        readOnly: readOnly,
      },
      inputRef: inputRef,
      inputProps: {
        maxLength: maxLength,
      },
      autoFocus: autoFocus,
      required: required,
      error: error,
      disabled: readOnly || disabled,
      helperText: error
        ? helpText
        : readOnly
        ? getString('contactDetails', 'READ_ONLY_HELP_TEXT')
        : '',
      multiline: multiline,
      FormHelperTextProps: {
        classes: {
          root: classes.help,
          error: classes.error,
        },
      },
      onKeyUp: onKeyUp,
      ...rest,
    };

    return (
      <div className={classes.root}>
        {Icon && (
          <Icon className={classes.icon} style={{ color: iconColour }} />
        )}
        <div className={classes.fieldContainer}>
          {formik ? (
            <Field
              {...sharedFieldAttributes}
              component={FormikTextField}
              margin='none'
            />
          ) : (
            <TextField {...sharedFieldAttributes} onChange={onChange} />
          )}

          {!readOnly && !disabled && value && clear ? (
            <ClearIcon
              className={classes.clear}
              onClick={this.clearField}
              data-component={id}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

IconTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  iconColour: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helpText: PropTypes.string,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  clear: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  formik: PropTypes.bool,
  onKeyUp: PropTypes.func,
};

IconTextField.defaultProps = {
  iconColour: '',
  autoFocus: false,
  required: false,
  error: false,
  helpText: '',
  maxLength: 60,
  type: 'text',
  clear: null,
  readOnly: false,
  disabled: false,
  multiline: false,
  formik: false,
  onKeyUp: null,
};

export default withStyles(styles)(IconTextField);
